/* assets/mb-store.js - GENERATED by port-behaviour.py from mock-v2/store.js.
   Do not edit here. Edit the mock's store.js and re-run, or the theme and the approved mock
   drift apart with nothing to notice it.

   Stage 5: the cart is Shopify's Ajax Cart API and the hash router is gone. Every other
   behaviour ships from the approved mock unchanged. */
/* ==========================================================================
   MagicBooks.bg  -  parity mock v2, behaviour layer
   --------------------------------------------------------------------------
   THREE RULES THIS FILE OBEYS (APPROACH.md, handoff 2026-09-12):

   1. NO `window.scrollY`, NO `window` scroll listeners. Horizon moves scrolling
      onto `.page-wrapper` above 990px, so anything window-bound dies silently on
      desktop. Scroll-direction work listens on `document` in the CAPTURE phase,
      which sees scroll events from ANY scrolling element, and reads the
      container that actually scrolled. Programmatic scrolling goes through
      getScrollContainer().
   2. Cart state lives in localStorage shaped EXACTLY like a Shopify CartLine:
      { merchandiseId, title, variantTitle, price, image, quantity }
      `price` is an integer in minor units (euro cents), same as /cart.js.
      The automatic discount is a CART-LEVEL line computed at render time, the
      way Shopify returns cart.cart_level_discount_applications; it is never
      baked into a variant price.
   3. Behaviour binds through data-* attributes and event delegation. There is
      not one inline handler in the markup.

   The catalogue, the discount rules and every UI string arrive from build.py
   (window.MB_CATALOG / MB_DISCOUNTS / MB_UI), read from the live product
   records, the Admin API discount and the theme's own settings + locale file.
   Nothing in here types live copy.

   PORT MAP for stage 5 (mock call -> real call):
      Cart.read()              ->  GET  /cart.js
      Cart.add(line, qty)      ->  POST /cart/add.js      {id, quantity}
      Cart.setQty(id, qty)     ->  POST /cart/change.js   {id, quantity}
      Cart.remove(id)          ->  POST /cart/change.js   {id, quantity: 0}
      Cart.note(text)          ->  POST /cart/update.js   {note}
      Cart.discounts()         ->  cart.cart_level_discount_applications
      money(cents)             ->  {{ price | money }}  (shop format is
                                   `{{amount_with_comma_separator}} €`, verified)
   ========================================================================== */
(function () {
  'use strict';

  var CATALOG = window.MB_CATALOG || {};
  var DISCOUNTS = window.MB_DISCOUNTS || [];
  var UI = window.MB_UI || {};
  var MAX_QTY = 99;
  var CART_KEY = 'mb_cart_v2';
  var NOTE_KEY = 'mb_cart_note_v2';
  var TIMER_KEY = 'mb_cart_timer_v2';
  var NBSP = ' ';

  /* ---------- 1. Money ---------------------------------------------------- */
  function money(cents) {
    var neg = cents < 0;
    var v = (Math.abs(Math.round(cents)) / 100).toFixed(2).replace('.', ',');
    return (neg ? '-' : '') + v + NBSP + '€';
  }
  function fill(template, map) {
    var out = template || '';
    Object.keys(map).forEach(function (k) { out = out.split('[' + k + ']').join(map[k]); });
    return out;
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* ---------- 2. Scroll container (Horizon-safe) -------------------------- */
  function getScrollContainer() {
    var pw = document.querySelector('.page-wrapper');
    if (pw && pw.scrollHeight > pw.clientHeight + 1 && getComputedStyle(pw).overflowY !== 'visible') return pw;
    return document.scrollingElement || document.documentElement;
  }
  function scrollToTop() {
    try { getScrollContainer().scrollTo({ top: 0, behavior: 'auto' }); }
    catch (e) { getScrollContainer().scrollTop = 0; }
  }

  /* ---------- 3. Catalogue lookups ---------------------------------------- */
  function findVariant(merchandiseId) {
    for (var h in CATALOG) {
      var p = CATALOG[h];
      for (var i = 0; i < p.variants.length; i++) {
        if (p.variants[i].merchandiseId === merchandiseId) return { product: p, variant: p.variants[i] };
      }
    }
    return null;
  }
  function lineFrom(merchandiseId) {
    var hit = findVariant(merchandiseId);
    if (!hit) return null;
    return {
      merchandiseId: merchandiseId,
      title: hit.product.title,
      variantTitle: hit.variant.title,
      price: hit.variant.price,
      image: hit.product.media[0] || ''
    };
  }

  /* ---------- 4. Cart (Shopify Ajax Cart API) -----------------------------
     STAGE 5. The mock kept this in localStorage shaped like a Shopify cart line, so the swap is
     an adapter, not a rewrite: section 8's renderers are untouched and still paint the approved
     markup byte for byte.

     Getters are synchronous and read STATE, a cache of the last /cart.js response, because the
     renderers call them while painting. Mutations POST, refresh the cache, then fire
     `cart:updated` - the event the renderers already listen to.

     Line identity is Shopify's `key`, not the variant id: the same variant can legitimately sit
     on two lines (different properties or selling plans) and changing one by variant id would
     silently move the wrong one. `merchandiseId` therefore carries the KEY, which is what the
     rendered data-id attributes hand back to setQty and remove, and `variantId` carries the
     numeric variant so the upsell toggle can still ask "is this product in the cart".        */
  var STATE = { items: [], original_total_price: 0, total_price: 0, total_discount: 0, item_count: 0, cart_level_discount_applications: [], note: '' };
  var inflight = null;

  function variantNumber(id) {
    var s = String(id || '');
    var m = s.match(/(\d+)\s*$/);
    return m ? m[1] : s;
  }

  function adapt(item) {
    return {
      merchandiseId: item.key,
      variantId: String(item.id),
      title: item.product_title || item.title,
      variantTitle: (item.variant_title && item.variant_title !== 'Default Title') ? item.variant_title : '',
      price: item.final_price,
      /* D2, 2026-09-13. Shopify's own line total, never final_price x quantity. An automatic
         discount that does not divide evenly by the quantity is allocated unevenly: 2 books at
         a 9,99 EUR discount are 500 + 499, so final_price is 2500 and final_line_price is 4999,
         not 5000. Recomputing money client-side made the printed lines sum to 56,00 EUR against
         a printed subtotal of 55,99. Read the total; never multiply it back out. */
      lineTotal: (item.final_line_price !== undefined && item.final_line_price !== null)
        ? item.final_line_price
        : item.final_price * item.quantity,
      /* D-MB-THM-071, 2026-11-05. The regular unit and line prices, before any discount is spread over the line: the
         cart page's unit price, the drawer's struck reference and the pair hint read them, so none of them is ever the
         per-unit average that made a discounted line look like a dearer set. */
      originalPrice: item.original_price,
      originalLineTotal: item.original_line_price,
      image: item.image || '',
      quantity: item.quantity,
      url: item.url || ''
    };
  }

  function announce() {
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: { lines: Cart.read() } }));
  }

  /* PENDING counts cart mutations in flight. Measured 2026-09-14 on a 390 viewport: after an
     add-to-cart the drawer OPENED at 114ms and read "Количка: 0 продукта / Вашата количка е
     празна" until 651ms, because it renders from the last /cart.js and the new line only exists
     after a POST plus a GET. Half a second of telling a customer their cart is empty at the exact
     moment they pressed buy is not a slow render, it is a false statement, and it is the one thing
     in this file that must never be shown. The renderer consults this and shows nothing rather
     than the empty state while a write is outstanding. */
  var PENDING = 0;
  function setPending(d) {
    PENDING = Math.max(0, PENDING + d);
    var dr = document.querySelector('[data-cart-drawer]');
    if (dr) { if (PENDING > 0) dr.setAttribute('data-cart-pending', 'true'); else dr.removeAttribute('data-cart-pending'); }
    /* Repaint NOW. Setting the flag without one was measured shipping unchanged behaviour: the
       drawer is opened by the click handler and shows whatever was last rendered, so the empty
       state stayed on screen until the network landed and the next render came with it. The flag
       is only worth anything if something reads it before the wait, not after. */
    try { if (typeof renderCount === 'function') renderCount(); } catch (e) {}
    try { if (typeof renderDrawer === 'function') renderDrawer(); } catch (e) {}
  }

  /* SELF_WRITE is how the external-mutation hook below tells our own cart writes apart from
     somebody else's. Ours already refresh through queue(); double-refreshing them would repaint
     the drawer twice for one click. */
  var SELF_WRITE = 0;

  function request(url, body) {
    var opts = { method: body ? 'POST' : 'GET', headers: { 'Accept': 'application/json' }, credentials: 'same-origin' };
    if (body) { opts.headers['Content-Type'] = 'application/json'; opts.body = JSON.stringify(body); }
    if (body) SELF_WRITE++;
    return fetch(url, opts).then(function (r) {
      if (body) SELF_WRITE--;
      return r.json().then(function (j) {
        if (!r.ok) throw new Error((j && (j.description || j.message)) || ('cart request failed: ' + r.status));
        return j;
      });
    }, function (e) { if (body) SELF_WRITE--; throw e; });
  }

  /* Cart subtotal fix, 2026-11-04 (the Merry Gifts engine's settle(), unchanged). Once a cart has a delivery address
     (Shopify's shipping estimate gives it one; a shopper back from checkout with an address typed in most likely has
     one too), the /cart/change.js response folds the estimated shipping into total_price while GET /cart.js does not.
     Measured on the live store: 2 book sets came back as 5348 with items_subtotal_price 4999 (the 3,49 office rate),
     and the drawer printed "Обща сума 53,48 €" and "Спестявате -26,52 €" for a 49,99 cart whose saving is 30,01.
     The merchandise total is items_subtotal_price less the cart-level discounts, which is what /cart.js reports;
     every cart the engine keeps is capped at it. Only ever lowers. Gate B9 in port-behaviour.py --verify. */
  function settle(c) {
    if (!c || typeof c.total_price !== 'number' || typeof c.items_subtotal_price !== 'number') return c;
    var cartLevel = (c.cart_level_discount_applications || []).reduce(function (n, d) { return n + (Number(d.total_allocated_amount) || 0); }, 0);
    var merch = c.items_subtotal_price - cartLevel;
    if (merch >= 0 && c.total_price > merch) c.total_price = merch;
    return c;
  }

  /* D-MB-THM-060: /cart.js at the root, never Shopify.routes.root + 'cart.js'. On 2026-09-28 the
     published renderer set Shopify.routes.root to "/en/" on Bulgarian pages for most of the day, and
     /en/cart.js handed back every line's url as /en/products/..., so the drawer linked to /en. */
  function refresh() {
    return request('/cart.js')
      .then(function (c) { STATE = settle(c); announce(); return c; })
      .catch(function (e) { console.warn('[mb-cart]', e); return STATE; });
  }

  /* STAGE 6. The cart UI is ours; the collection and search grids are Horizon's. Horizon's
     quick-add posts straight to /cart/add.js and announces it on an event our renderers do not
     listen to, so clicking "Добави" on a product card put the item in Shopify's cart while our
     header count stayed at 0 and our drawer still read "Вашата количка е празна" until the next
     page load. Measured on the preview, 2026-09-14.

     Hooking the two transports rather than Horizon's event name is deliberate: it catches every
     writer - Horizon, an app, a future section - and a Horizon upgrade that renames an internal
     event cannot silently switch it off. Only the four MUTATION endpoints are watched, so
     refresh()'s own GET of /cart.js can never feed itself. */
  var CART_MUTATION = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  var externalPing = null;
  function onExternalCartWrite() {
    clearTimeout(externalPing);
    externalPing = setTimeout(function () { refresh(); }, 150);
  }
  (function hookExternalCartWrites() {
    if (window.fetch) {
      var _fetch = window.fetch;
      window.fetch = function (input, init) {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        var watch = CART_MUTATION.test(url) && !SELF_WRITE;
        var out = _fetch.apply(this, arguments);
        if (watch && out && out.then) {
          out.then(function (r) { if (r && r.ok) onExternalCartWrite(); }, function () {});
        }
        return out;
      };
    }
    var _open = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (method, url) {
      this.__mbCartWrite = CART_MUTATION.test(String(url || '')) && !SELF_WRITE;
      return _open.apply(this, arguments);
    };
    var _send = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.send = function () {
      if (this.__mbCartWrite) {
        this.addEventListener('load', function () { if (this.status < 400) onExternalCartWrite(); });
      }
      return _send.apply(this, arguments);
    };
  })();

  /* Every mutation is chained onto the last one. Two fast clicks on + would otherwise race and
     the second could be written from a cart state the first had already replaced. */
  /* Every mutation used to POST and then GET /cart.js before anything repainted, so the upsell
     switch took 492ms to flip on a 390 viewport (measured 2026-09-14) for what is one boolean.
     /cart/change.js, /cart/update.js and /cart/clear.js all RETURN the whole cart, so the second
     round trip was pure ceremony: take the response. /cart/add.js returns only the added lines
     and no total_price, so it still refreshes, which the total_price test below routes correctly
     without knowing which endpoint was called. */
  function isWholeCart(r) {
    return !!(r && r.items && typeof r.total_price === 'number' && typeof r.item_count === 'number');
  }
  function queue(fn) {
    setPending(1);
    inflight = (inflight || Promise.resolve()).then(fn).then(function (res) {
      if (isWholeCart(res)) { STATE = settle(res); announce(); return res; }
      return refresh();
    }).catch(function (e) {
      console.warn('[mb-cart]', e);
      if (typeof toast === 'function') toast(String(e.message || e));
      return refresh();
    }).then(function (r) { setPending(-1); renderAll(); return r; });
    return inflight;
  }

  var Cart = {
    read: function () { return (STATE.items || []).map(adapt); },
    count: function () { return STATE.item_count || 0; },
    /* pre-discount, because the drawer prints the discount as its own line */
    subtotal: function () { return STATE.original_total_price || 0; },
    /* D4, 2026-09-13. This shop's automatic discount is allocated PER LINE, not at cart level:
       /cart.js returns cart_level_discount_applications: [] and puts `2xBOOKS-SALE` on
       items[].line_level_discount_allocations. Reading only the cart-level array printed an
       empty discounts row, so the customer saw a reduced price with no reason given. Read both,
       and aggregate the line-level ones by title so one promotion is one row rather than one
       row per line. The header comment of this file used to assert cart-level; it was wrong. */
    discounts: function () {
      var rows = [], seen = {};
      var push = function (title, amount) {
        if (!amount) return;
        if (seen[title] === undefined) { seen[title] = rows.length; rows.push({ title: title, amount: 0 }); }
        rows[seen[title]].amount += amount;
      };
      (STATE.cart_level_discount_applications || []).forEach(function (d) {
        push(d.title || d.description || '', d.total_allocated_amount || 0);
      });
      (STATE.items || []).forEach(function (item) {
        var allocs = (item.line_level_discount_allocations && item.line_level_discount_allocations.length)
          ? item.line_level_discount_allocations
          : (item.discounts || []);
        allocs.forEach(function (a) {
          var da = a.discount_application || {};
          push(da.title || da.description || a.title || a.description || '', a.amount || 0);
        });
      });
      return rows;
    },
    discountTotal: function () { return STATE.total_discount || 0; },
    total: function () { return STATE.total_price || 0; },
    /* D3, 2026-09-13. This used to be compareSavings() + discountTotal(), and it double-counted:
       compareSavings subtracted item.final_price, which ALREADY has the discount in it, and then
       the discount was added on top. Measured on 2 books: it printed 39,99 EUR where the true
       saving is 30,01. Compute it ONCE, as what the lines would have cost at their highest
       advertised price minus what Shopify says the cart costs. Per line that is the greater of
       the compare-at total and the pre-discount line price, so an item with a compare-at and an
       item with only a discount are both counted, and neither is counted twice. */
    savings: function () {
      var was = (STATE.items || []).reduce(function (n, item) {
        var hit = findVariant('gid://shopify/ProductVariant/' + item.id) || findVariant(String(item.id));
        var ca = (hit && hit.variant.compareAt) ? hit.variant.compareAt * item.quantity : 0;
        var orig = item.original_line_price || (item.price * item.quantity) || 0;
        return n + Math.max(ca, orig);
      }, 0);
      return Math.max(0, was - (STATE.total_price || 0));
    },
    has: function (id) {
      var want = variantNumber(id);
      return (STATE.items || []).some(function (i) { return String(i.id) === want || i.key === id; });
    },
    add: function (line, qty) {
      qty = Math.max(1, qty || 1);
      return queue(function () {
        return request('/cart/add.js', { items: [{ id: Number(variantNumber(line.merchandiseId)), quantity: Math.min(MAX_QTY, qty) }] });
      });
    },
    setQty: function (key, qty) {
      return queue(function () {
        return request('/cart/change.js', { id: key, quantity: Math.max(0, Math.min(MAX_QTY, qty)) });
      });
    },
    remove: function (key) { return Cart.setQty(key, 0); },
    /* D7, 2026-09-14. The upsell toggle used to read Cart.has() at CLICK time and branch
       add-vs-remove on it. has() reads the cached /cart.js, which only changes once the round
       trip lands, so two taps inside one round trip BOTH saw "not in cart" and BOTH added.
       Measured on the live theme, 390 viewport: an 80-250ms double tap left pens x2 and a
       41,99 EUR cart, and repeated taps reached x4 / 53,99 EUR, with the drawer printing a
       total that no longer matched Shopify's cart at all. The customer had tapped a switch
       twice and been given four pens.

       So the caller asks for an END STATE and this resolves it INSIDE the queue, against the
       cart that has actually settled. A repeat tap is then a no-op rather than a second add,
       and when taps are queued the last one wins, which is what the switch on screen says. */
    setUpsell: function (line, wanted) {
      return queue(function () {
        var want = variantNumber(line.merchandiseId);
        var hit = (STATE.items || []).filter(function (i) { return String(i.id) === want; })[0];
        if (wanted && !hit) return request('/cart/add.js', { items: [{ id: Number(want), quantity: 1 }] });
        if (!wanted && hit) return request('/cart/change.js', { id: hit.key, quantity: 0 });
        return STATE;   /* already in the wanted state: no write, and no repaint surprise */
      });
    },
    /* the upsell toggle asks by VARIANT, so it has to find that variant's line key first */
    removeVariant: function (id) {
      var want = variantNumber(id);
      var hit = (STATE.items || []).filter(function (i) { return String(i.id) === want; })[0];
      return hit ? Cart.setQty(hit.key, 0) : Promise.resolve();
    },
    note: function (text) {
      if (text === undefined) return STATE.note || '';
      return queue(function () { return request('/cart/update.js', { note: text }); });
    },
    refresh: refresh
  };

  function isLine(l) {
    return l && typeof l.merchandiseId === 'string' && typeof l.price === 'number'
        && typeof l.quantity === 'number' && l.quantity > 0;
  }

  /* ---------- 5. Countdown timer (cart drawer block) ----------------------
     Mirrors the live CountdownTimer element (spec cart-drawer 5.3): MM:SS zero
     padded, first paint 05:00, starts counting the first time the drawer opens,
     never paused on close, NOT persisted across page loads, and when it reaches
     00:00 it continues from 01:30 (the element resets a zero duration to 90 s).
     It never expires the cart.                                              */
  var Timer = {
    seconds: (UI.timerSeconds || 300),
    left: null,
    handle: null,
    paint: function () {
      var l = Timer.left === null ? Timer.seconds : Timer.left;
      var m = Math.floor(l / 60), s = l % 60;
      var txt = (m < 10 ? '0' : '') + m + ':' + (s < 10 ? '0' : '') + s;
      document.querySelectorAll('[data-timer]').forEach(function (el) { el.textContent = txt; });
    },
    start: function () {
      if (Timer.left === null) Timer.left = Timer.seconds;
      if (Timer.handle) return;
      Timer.paint();
      Timer.handle = setInterval(function () {
        Timer.left -= 1;
        if (Timer.left < 0) Timer.left = 90;
        Timer.paint();
      }, 1000);
    }
  };

  /* ---------- 6. Panels (drawer, menu) ------------------------------------ */
  var lastFocus = null;
  function lockScroll(on) {
    var pw = document.querySelector('.page-wrapper');
    document.body.style.overflow = on ? 'hidden' : '';
    if (pw) pw.style.overflow = on ? 'hidden' : '';
  }
  function openPanel(el) {
    if (!el) return;
    lastFocus = document.activeElement;
    document.querySelectorAll('[data-panel]').forEach(function (p) {
      if (p !== el) { p.setAttribute('data-open', 'false'); p.setAttribute('aria-hidden', 'true'); }
    });
    el.setAttribute('data-open', 'true');
    el.removeAttribute('aria-hidden');
    document.querySelector('[data-scrim]').setAttribute('data-open', 'true');
    lockScroll(true);
    if (el.hasAttribute('data-cart-drawer')) Timer.start();
    var f = el.querySelector('[data-close], button, a');
    if (f) f.focus();
  }
  function closePanels() {
    document.querySelectorAll('[data-panel]').forEach(function (p) {
      p.setAttribute('data-open', 'false');
      p.setAttribute('aria-hidden', 'true');
    });
    document.querySelector('[data-scrim]').setAttribute('data-open', 'false');
    lockScroll(false);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
    lastFocus = null;
  }

  /* ---------- 7. Toast ---------------------------------------------------- */
  var toastTimer = null;
  function toast(msg) {
    var t = document.querySelector('[data-toast]');
    if (!t) return;
    t.textContent = msg;
    t.setAttribute('data-show', 'true');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.setAttribute('data-show', 'false'); }, 2600);
  }

  /* ---------- 8. Renderers ------------------------------------------------ */
  function renderCount() {
    var n = Cart.count();
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = String(n);
      el.setAttribute('data-empty', n === 0 ? 'true' : 'false');
      var btn = el.closest('[data-open-cart]');
      /* [count], never {{ count }}: snippets/mb-store-data.liquid is Liquid, which empties {{ count }} before the page
         loads, so the icon was read out „ елемента“ with no number (measured on live, 31.10.2026). */
      if (btn) btn.setAttribute('aria-label', fill(n === 1 ? (UI.cartCount && UI.cartCount.one) : (UI.cartCount && UI.cartCount.other), { count: n }));
    });
    document.querySelectorAll('[data-drawer-heading]').forEach(function (el) {
      if (PENDING > 0 && n === 0) {
        el.textContent = String(UI.drawerHeading || '').replace(/[:\s]*\[count\].*$/, '').trim();
        return;
      }
      el.textContent = fill(n === 1 && UI.drawerHeadingOne ? UI.drawerHeadingOne : UI.drawerHeading, { count: n });
    });
  }

  function qtyControl(merchandiseId, quantity, label) {
    /* [product] and [title], never {{ }}: snippets/mb-store-data.liquid is Liquid, which empties {{ product }} and
       {{ title }} before the page loads, so the line buttons were read out „Премахване на “ with no name (31.10.2026). */
    var inc = fill(UI.qtyIncrease, { product: label });
    var dec = fill(UI.qtyDecrease, { product: label });
    var inp = fill(UI.qtyInput, { product: label });
    return '<div class="qty">' +
      '<button type="button" data-qty="dec" data-id="' + esc(merchandiseId) + '" aria-label="' + esc(dec) + '"><svg viewBox="0 0 24 24" aria-hidden="true" class="ico"><path d="M5 12h14"/></svg></button>' +
      '<output aria-label="' + esc(inp) + '">' + quantity + '</output>' +
      '<button type="button" data-qty="inc" data-id="' + esc(merchandiseId) + '" aria-label="' + esc(inc) + '"><svg viewBox="0 0 24 24" aria-hidden="true" class="ico"><path d="M12 5v14M5 12h14"/></svg></button>' +
      '</div>';
  }

  function lineMarkup(l, compact) {
    /* 2026-11-05 (D-MB-THM-071). A drawer line printed final_price, Shopify's unit price after the discount is spread
       over the line, so the books read 25,00 €, then 26,66 €, then 27,50 € as sets were added, and buyers took the
       average for the price of a set (owner, with screenshots). A drawer line now prints what the whole line costs,
       struck against the reference for the same quantity; the cart page keeps the regular unit price, because its
       total column carries the line. Also looked up by variant: on the theme merchandiseId is Shopify's LINE KEY,
       which the catalogue cannot match, so no compare-at had ever reached a cart line there. The per-line saving
       went: the drawer's footer states the saving once, for the whole cart. */
    var hit = findVariant(l.merchandiseId) || (l.variantId ? findVariant('gid://shopify/ProductVariant/' + l.variantId) : null);
    var ca = hit && hit.variant.compareAt ? hit.variant.compareAt : 0;
    var total = typeof l.lineTotal === 'number' ? l.lineTotal : l.price * l.quantity;
    var unit = typeof l.originalPrice === 'number' ? l.originalPrice : l.price;
    var shown = compact ? total : unit;
    var ref = compact ? Math.max(ca * l.quantity, typeof l.originalLineTotal === 'number' ? l.originalLineTotal : 0) : ca;
    var showVariant = l.variantTitle && l.variantTitle !== 'Default Title';
    var removeLabel = fill(UI.removeTitle, { title: l.title });
    var link = l.url || '#';   /* Shopify's own line URL; never the mock's hash route */
    return '<div class="' + (compact ? 'cd-line' : 'cart-line') + '" data-line="' + esc(l.merchandiseId) + '">' +
      '<a class="cl-img" href="' + esc(link) + '"><img src="' + esc(l.image) + '" alt="" width="80" height="80" loading="lazy"></a>' +
      '<div class="cl-body">' +
        '<a class="cl-title" href="' + esc(link) + '">' + esc(l.title) + '</a>' +
        (showVariant ? '<div class="cl-variant">' + esc(l.variantTitle) + '</div>' : '') +
        '<div class="cl-prices"><span class="cl-price money">' + money(shown) + '</span>' +
          (ref > shown ? '<s class="cl-compare money">' + money(ref) + '</s>' : '') +
        '</div>' +
        '<div class="cl-foot">' + qtyControl(l.merchandiseId, l.quantity, l.title) +
          '<button type="button" class="cl-remove" data-remove data-id="' + esc(l.merchandiseId) + '" aria-label="' + esc(removeLabel) + '"><svg viewBox="0 0 24 24" aria-hidden="true" class="ico"><path d="M4 7h16M9 7V5h6v2m-7 0 1 13h6l1-13"/></svg></button>' +
        '</div>' +
        pairHint(l, unit) +
      '</div>' +
      (compact ? '' : '<div class="cl-total money">' + money(l.lineTotal) + '</div>') +
    '</div>';
  }

  /* The every-2-sets deal (D-MB-THM-071). An odd number of sets is one set short of the next pair, so the line offers
     that set at what it adds to the bill. window.MB_PAIRS maps a numeric variant id to { off: the cents a pair earns,
     max: the pairs the discount steps go up to }; on the theme it comes, with UI.pairHint, from the hand-written
     snippets/mb-cart-pairs.liquid, and without both nothing renders. The button is the line's own + (data-qty="inc"),
     so it needs no handler of its own and the drawer's refocus lands on the stepper once the hint is gone. */
  function pairHint(l, unit) {
    var deal = (window.MB_PAIRS || {})[String(l.variantId || l.merchandiseId || '').replace(/^.*\//, '')];
    if (!UI.pairHint || !deal || l.quantity % 2 === 0 || (l.quantity + 1) / 2 > deal.max) return '';
    return '<button type="button" class="cl-hint" data-qty="inc" data-id="' + esc(l.merchandiseId) + '">' +
      esc(fill(UI.pairHint, { price: money(unit - deal.off).replace(NBSP, ' ') })).replace(/ €/g, NBSP + '€') + '</button>';
  }

  function discountsMarkup() {
    var ds = Cart.discounts();
    if (!ds.length) return '';
    return '<div class="discounts">' + (UI.discountsLabel ? '<span class="discounts-label">' + esc(UI.discountsLabel) + '</span>' : '') +
      ds.map(function (d) {
        return '<span class="discount-line"><svg viewBox="0 0 24 24" aria-hidden="true" class="ico"><path d="M4 12l8-8h8v8l-8 8z"/><circle cx="16" cy="8" r="1.5"/></svg>' +
          '<span class="discount-title">' + esc(d.title) + '</span><span class="money">-' + money(d.amount) + '</span></span>';
      }).join('') + '</div>';
  }

  /* data-requires: an addon is an addon TO something. The pens toggle is only an offer while the
     books set is in the cart; on a cart that never held it there is nothing to add pens to, so
     the offer goes away rather than sitting there unattached. No attribute means unconditional,
     which is what every other upsell gets. Owner's call, 2026-09-14. */
  function upsellOffered(u) {
    var req = (u.getAttribute('data-requires') || '').split(',').filter(Boolean);
    return !req.length || req.some(function (r) { return Cart.has(r); });
  }

  /* Writing innerHTML unconditionally re-creates every child node, which is what makes the cart
     visibly flicker when a paint changes nothing.

     Compare against what we LAST WROTE, never against el.innerHTML. Reading innerHTML back gives
     the browser's own normalised serialisation - attribute order, quoting, void elements - which
     never equals the string we generated, so a guard written that way fires never. Measured
     2026-09-14: three writes inside 4ms, all producing html of the identical 1631 characters,
     with the naive guard in place. */
  function setHTML(el, html) {
    if (!el) return;
    if (el.__mbHTML === html) return;
    el.__mbHTML = html;
    el.innerHTML = html;
  }

  function renderDrawer() {
    var drawer = document.querySelector('[data-cart-drawer]');
    if (!drawer) return;
    var act = document.activeElement, refocus = null;
    if (act && act.getAttribute && act.hasAttribute('data-qty') && drawer.contains(act)) {
      refocus = { dir: act.getAttribute('data-qty'), id: act.getAttribute('data-id') };
    }
    var lines = Cart.read().slice().reverse();                 /* Shopify lists the newest line first */
    /* Only an upsell that is actually BEING OFFERED may hide its own line. Otherwise, the moment
       the offer withdraws - the books set is removed, so the pens addon is no longer an addon to
       anything - a pen already in the cart would be filtered out of the list while still counting
       towards the heading and the total: a drawer showing no lines over a 6,00 EUR bill. The
       hidden line is a presentation trick that belongs to the offer, so it lives and dies with it. */
    var hiddenIds = [];
    drawer.querySelectorAll('[data-upsell][data-variant]').forEach(function (u) {
      if (upsellOffered(u)) hiddenIds.push(u.getAttribute('data-variant'));
    });
    var empty = drawer.querySelector('[data-drawer-empty]');
    var filled = drawer.querySelector('[data-drawer-filled]');
    if (empty) empty.hidden = lines.length > 0 || PENDING > 0;
    if (filled) filled.hidden = lines.length === 0;
    var list = drawer.querySelector('[data-drawer-lines]');
    /* the live drawer hides the upsell product's line item with an inline style; the
       heading count and the totals still include it (spec cart-drawer, note 7) */
    if (list) setHTML(list, lines.filter(function (l) { return hiddenIds.indexOf(l.variantId) === -1 && hiddenIds.every(function (h) { return String(h).replace(/\D+/g, '') !== String(l.variantId); }); }).map(function (l) { return lineMarkup(l, true); }).join(''));
    var sv = drawer.querySelector('[data-drawer-savings]');
    if (sv) {
      var s = Cart.savings();
      sv.hidden = s <= 0;
      var amt = sv.querySelector('[data-amount]'); if (amt) setHTML(amt, '-' + money(s));
    }
    var dl = drawer.querySelector('[data-drawer-discounts]');
    if (dl) setHTML(dl, discountsMarkup());
    var st = drawer.querySelector('[data-drawer-subtotal]');
    if (st) st.textContent = money(Cart.total());
    /* upsell block: the switch mirrors whether the variant is in the cart; with
       hide_in_cart_items the whole block hides while the product is in the cart */
    drawer.querySelectorAll('[data-upsell]').forEach(function (u) {
      var vid = u.getAttribute('data-variant');
      var inCart = Cart.has(vid);
      if (PENDING === 0) u.querySelectorAll('[data-upsell-toggle]').forEach(function (sw) { sw.setAttribute('aria-checked', inCart ? 'true' : 'false'); });
      u.hidden = !upsellOffered(u) || (u.getAttribute('data-hide-in-cart') === 'true' && inCart);
    });
    /* the question above the offer is its own block, so it hides with it rather than being
       left to ask about something that is no longer on screen */
    drawer.querySelectorAll('[data-upsell-heading]').forEach(function (h) {
      var block = h.nextElementSibling;
      while (block && !block.querySelector('[data-upsell]')) block = block.nextElementSibling;
      var any = block ? [].slice.call(block.querySelectorAll('[data-upsell]')).some(function (u) { return !u.hidden; }) : false;
      h.hidden = !any;
    });
    if (refocus) {
      var again = list && list.querySelector('[data-qty="' + refocus.dir + '"][data-id="' + refocus.id + '"]');
      if (again) again.focus();
      else { var c = drawer.querySelector('[data-close]'); if (c) c.focus(); }
    }
  }

  function renderCartPage() {
    /* the cart page is two live sections (main-cart-items + main-cart-footer), so the
       hooks are scoped to the route wrapper, not to one section */
    /* STAGE 5: the mock scoped this to its route wrapper; a real cart page has no such
       wrapper, and scoping to one that does not exist made this function a no-op. */
    var root = document;
    if (!document.querySelector('[data-cart-lines]')) return;
    var lines = Cart.read().slice().reverse();
    root.querySelectorAll('[data-cart-filled]').forEach(function (el) { el.hidden = lines.length === 0; });
    root.querySelectorAll('[data-cart-empty]').forEach(function (el) { el.hidden = lines.length > 0; });
    var list = root.querySelector('[data-cart-lines]');
    if (list) setHTML(list, lines.map(function (l) { return lineMarkup(l, false); }).join(''));
    var sub = root.querySelector('[data-cart-subtotal]');
    if (sub) sub.textContent = money(Cart.total());
    var ds = root.querySelector('[data-cart-discounts]');
    if (ds) setHTML(ds, discountsMarkup());
    var cnt = root.querySelector('[data-cart-line-count]');
    if (cnt) cnt.textContent = String(Cart.count());
  }

  function renderAll() { renderCount(); renderDrawer(); renderCartPage(); }

  /* ---------- 9. PDP: bundle option -> quantity, gallery ------------------ */
  function selectedQty(scope) {
    var on = (scope || document).querySelector('[data-bundle-option][data-on="true"]');
    return on ? parseInt(on.getAttribute('data-bundle-option') || '1', 10) : 1;
  }
  function selectBundleOption(el) {
    var scope = el.closest('[data-block="product_quantity-selector"]') || el.closest('[data-section]') || document;
    scope.querySelectorAll('[data-bundle-option]').forEach(function (o) { o.setAttribute('data-on', 'false'); var r = o.querySelector('input'); if (r) r.checked = false; });
    el.setAttribute('data-on', 'true');
    var radio = el.querySelector('input'); if (radio) radio.checked = true;
    var section = el.closest('[data-section]');
    if (section) section.querySelectorAll('[data-qty-input]').forEach(function (i) { i.value = el.getAttribute('data-bundle-option'); });
  }

  /* ---------- 10. Sticky header: hide on scroll down, show on scroll up ----
     Capture-phase listener on document: fires for the window AND for any
     scrolling element such as Horizon's .page-wrapper. No window binding.   */
  function initStickyHeader() {
    var header = document.querySelector('[data-sticky-header]');
    if (!header) return;
    var last = 0;
    document.addEventListener('scroll', function (ev) {
      var t = ev.target;
      var top = (t === document || t === document.documentElement || t === document.body)
        ? (document.scrollingElement || document.documentElement).scrollTop
        : (t && typeof t.scrollTop === 'number' ? t.scrollTop : 0);
      var h = header.offsetHeight;
      if (top > last && top > h * 1.5) header.setAttribute('data-hidden', 'true');
      else header.setAttribute('data-hidden', 'false');
      header.setAttribute('data-scrolled', top > 4 ? 'true' : 'false');
      last = top;
    }, true);
  }

  /* ---------- 11. Routing -------------------------------------------------
     STAGE 5. The mock's hash router is gone: Liquid templates are real pages now. All that is
     left of it is the active-navigation state, which the mock derived from its route and the
     theme derives from the URL it is actually on.                                            */
  /* STAGE 5. The mock's checkout button was inert by design (data-checkout-disabled + disabled).
     port-mock.py rewrites those attributes to data-checkout; this is what makes it go. A GET to
     /checkout is what Shopify's own cart form does, and it carries the session cart.
     D-MB-THM-060: literally /checkout. The checkout's language follows the path alone (measured
     2026-09-28: /checkout opens .../bg-bg, /en/checkout opens .../en-bg, whatever the visitor browsed
     before), and Shopify.routes.root read "/en/" on Bulgarian pages that day, which sent buyers who
     left through this handler into the part-English checkout (4 of the 14 orders after 11:39). */
  function bindCheckout() {
    document.addEventListener('click', function (ev) {
      var b = ev.target.closest && ev.target.closest('[data-checkout]');
      if (!b) return;
      ev.preventDefault();
      if (Cart.count() === 0) { toast(UI.empty || ''); return; }
      b.setAttribute('aria-busy', 'true');
      window.location.href = '/checkout';
    });
  }

  function markActiveNav() {
    var here = location.pathname.replace(/\/+$/, '') || '/';
    document.querySelectorAll('[data-nav-link]').forEach(function (a) {
      var href = (a.getAttribute('href') || '').split('?')[0].replace(/\/+$/, '') || '/';
      if (href === here) a.setAttribute('aria-current', 'page');
      else a.removeAttribute('aria-current');
    });
  }

  /* ---------- 12. Delegated events ---------------------------------------- */
  document.addEventListener('click', function (ev) {
    var t = ev.target;
    var el;

    if ((el = t.closest('[data-open-cart]'))) {
      ev.preventDefault(); openPanel(document.querySelector('[data-cart-drawer]')); return;
    }
    if ((el = t.closest('[data-open-menu]'))) {
      ev.preventDefault(); openPanel(document.querySelector('[data-mobile-menu]')); return;
    }
    var closer = t.closest('[data-close]');
    if (closer || t.closest('[data-scrim]')) {
      var closeHref = (closer && closer.tagName === 'A') ? closer.getAttribute('href') : null;
      if (!closeHref) ev.preventDefault();
      closePanels();
      return;
    }
    if ((el = t.closest('[data-add]'))) {
      ev.preventDefault();
      var vid = el.getAttribute('data-variant');
      var line = lineFrom(vid);
      if (!line) return;
      var scope = el.closest('[data-section]');
      var qty = parseInt(el.getAttribute('data-qty-add') || '0', 10) || selectedQty(scope);
      Cart.add(line, qty);
      toast(UI.itemAdded || '');
      openPanel(document.querySelector('[data-cart-drawer]'));
      return;
    }
    if ((el = t.closest('[data-upsell-toggle]'))) {
      ev.preventDefault();
      var uv = el.getAttribute('data-variant');
      var ul = lineFrom(uv);
      if (!ul) return;
      /* Flip the SWITCH and ask the cart to match it. Reading Cart.has() here instead would
         branch on a cart state that, in the theme, is one network round trip stale. */
      var wanted = el.getAttribute('aria-checked') !== 'true';
      el.setAttribute('aria-checked', wanted ? 'true' : 'false');
      Cart.setUpsell(ul, wanted);
      return;
    }
    if ((el = t.closest('[data-upsell-add]'))) {
      ev.preventDefault();
      var av = el.getAttribute('data-variant');
      var al = lineFrom(av); if (al) { Cart.add(al, 1); toast(UI.itemAdded || ''); }
      return;
    }
    if ((el = t.closest('[data-qty]'))) {
      ev.preventDefault();
      var id = el.getAttribute('data-id');
      var dir = el.getAttribute('data-qty') === 'inc' ? 1 : -1;
      var cur = 0;
      Cart.read().forEach(function (l) { if (l.merchandiseId === id) cur = l.quantity; });
      Cart.setQty(id, cur + dir);
      return;
    }
    if ((el = t.closest('[data-remove]'))) {
      ev.preventDefault(); Cart.remove(el.getAttribute('data-id')); return;
    }
    if ((el = t.closest('[data-bundle-option]'))) {
      selectBundleOption(el);
      return;
    }
    if ((el = t.closest('[data-scroll-to]'))) {
      /* rating stars -> the reviews widget; scrollIntoView is container-agnostic (Horizon-safe) */
      ev.preventDefault();
      var tgt = document.querySelector(el.getAttribute('data-scroll-to'));
      if (tgt) tgt.scrollIntoView({ behavior: 'smooth', block: 'start' });
      return;
    }
    if ((el = t.closest('[data-thumb]'))) {
      ev.preventDefault();
      var gal = el.closest('[data-gallery]') || document;
      var stage = gal.querySelector('[data-gallery-stage]');
      goToSlide(gal, el.getAttribute('data-img'));
      gal.querySelectorAll('[data-thumb]').forEach(function (b) { b.setAttribute('aria-current', 'false'); });
      el.setAttribute('aria-current', 'true');
      return;
    }
    if ((el = t.closest('[data-slider-prev],[data-slider-next]'))) {
      ev.preventDefault();
      var wrap = el.closest('[data-slider]');
      var track = wrap && wrap.querySelector('.track');
      if (!track || !track.firstElementChild) return;
      var step = track.firstElementChild.getBoundingClientRect().width + (parseFloat(getComputedStyle(track).columnGap) || 0);
      track.scrollBy({ left: el.hasAttribute('data-slider-next') ? step : -step, behavior: 'smooth' });
      return;
    }
    if ((el = t.closest('[data-vid-toggle]'))) {
      /* pause/resume a decorative muted loop (theme setting video_muted_autoplay) */
      ev.preventDefault();
      var wrapA = el.closest('.vid');
      var vidA = wrapA && wrapA.querySelector('video');
      if (!vidA) return;
      if (vidA.paused) { wrapA.removeAttribute('data-paused'); playSafe(vidA); }
      else { vidA.pause(); wrapA.setAttribute('data-paused', 'true'); }
      paintToggle(wrapA);
      return;
    }
    if ((el = t.closest('[data-play]'))) {
      ev.preventDefault();
      var wrapV = el.closest('.vid');
      var video = wrapV && wrapV.querySelector('video');
      if (!video) return;
      soloVideo(video);
      wrapV.setAttribute('data-playing', 'true');
      playSafe(video);
      return;
    }
    if ((el = t.closest('.vid:not(.vid--auto) video'))) {
      /* Tapping the picture toggles, so a visitor is never stuck with a clip they cannot stop.
         Unambiguous now that no clip carries native controls: there is no browser control bar
         under the pointer that would toggle a second time and cancel this one out. */
      var vidT = el;
      if (vidT.paused) { soloVideo(vidT); playSafe(vidT); }
      else vidT.pause();
      return;
    }
    if (t.closest('.has-sub .sub-nav a')) {
      /* a dropdown link navigates (hash route) and the dropdown closes behind it, so the
         next click on the parent opens a fresh menu instead of toggling a stale open one */
      document.querySelectorAll('.has-sub').forEach(function (x) { x.setAttribute('aria-expanded', 'false'); });
      return;
    }
    if ((el = t.closest('.has-sub > .nav-top'))) {
      ev.preventDefault();
      var li = el.parentElement;
      var open = li.getAttribute('aria-expanded') === 'true';
      document.querySelectorAll('.has-sub').forEach(function (x) { x.setAttribute('aria-expanded', 'false'); });
      li.setAttribute('aria-expanded', open ? 'false' : 'true');
      return;
    }
    if (!t.closest('.has-sub')) {
      document.querySelectorAll('.has-sub').forEach(function (x) { x.setAttribute('aria-expanded', 'false'); });
    }
    if ((el = t.closest('[data-menu-sub-toggle]'))) {
      ev.preventDefault();
      var mli = el.closest('li');
      var mo = mli.getAttribute('aria-expanded') === 'true';
      mli.setAttribute('aria-expanded', mo ? 'false' : 'true');
      return;
    }
  });

  document.addEventListener('keydown', function (ev) {
    if (ev.key === 'Escape') closePanels();
  });
  document.addEventListener('input', function (ev) {
    if (ev.target.matches('[data-cart-note]')) Cart.note(ev.target.value);
  });
  document.addEventListener('play', function (ev) {
    var w = ev.target && ev.target.closest && ev.target.closest('.vid');
    if (w) { w.setAttribute('data-playing', 'true'); paintToggle(w); }
  }, true);
  document.addEventListener('cart:updated', renderAll);

  /* ---------- 12b. Video and slider affordances --------------------------- */
  function playSafe(v) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }

  /* MEASURED 2026-09-13, owner walk round 2. The poster showed the theme's 72px play button AND
     the browser's own control bar with a second play triangle 160px below it: two play buttons on
     one clip. Native controls are gone in both states (see ctx.video), so the clip is driven by
     the theme's own chrome and the icon has to follow the ELEMENT rather than the moment we
     happened to look at it - the same lesson as the autoplay toggle in round 1. */
  function bindClipState(w) {
    var v = w.querySelector('video');
    if (!v || w.dataset.bound) return;
    w.dataset.bound = '1';
    v.addEventListener('play', function () { paintToggle(w); });
    v.addEventListener('pause', function () { paintToggle(w); });
    v.addEventListener('ended', function () { w.removeAttribute('data-playing'); });
    paintToggle(w);
  }
  function initClipControls() {
    document.querySelectorAll('.vid:not(.vid--auto)').forEach(bindClipState);
  }

  /* An arrow pair that pages a track with no overflow is pure chrome, and this mock had one:
     the media slider under "Вижте ги в действие:" renders 3 slides at 3 per view, so its track
     scrolled 0px at every desktop width while two circles sat on top of the first and last clip.
     Overflow is a measurement, not a setting, so it is measured - here, per width, and re-measured
     whenever the layout can have moved. CSS reads data-scrollable and hides both affordances. */
  function measureTracks() {
    document.querySelectorAll('[data-slider]').forEach(function (wrap) {
      var track = wrap.querySelector('.track');
      if (!track) return;
      wrap.setAttribute('data-scrollable', track.scrollWidth - track.clientWidth > 2 ? 'true' : 'false');
    });
  }
  var measureTick = null;
  function scheduleMeasure() {
    if (measureTick) return;
    measureTick = requestAnimationFrame(function () { measureTick = null; measureTracks(); fitReviewTrack(); repaintDots(); });
  }
  window.addEventListener('resize', scheduleMeasure);
  window.addEventListener('load', scheduleMeasure);
  document.addEventListener('load', function (ev) {
    /* an image or a poster that arrives late changes the track width under us */
    if (ev.target && ev.target.closest && ev.target.closest('.track')) scheduleMeasure();
  }, true);

  /* one video at a time: a phone with three clips in a row should never play two at once */
  function soloVideo(keep) {
    document.querySelectorAll('.vid:not(.vid--auto) video').forEach(function (v) {
      if (v !== keep && !v.paused) { v.pause(); var w = v.closest('.vid'); if (w) w.removeAttribute('data-playing'); }
    });
  }

  function paintToggle(wrap) {
    var btn = wrap.querySelector('[data-vid-toggle]');
    var vid = wrap.querySelector('video');
    if (!btn || !vid) return;
    var paused = vid.paused;
    btn.setAttribute('aria-label', paused ? 'Пускане на видеото' : 'Пауза на видеото');
    btn.innerHTML = paused ? ICON_PLAY : ICON_PAUSE;
  }
  var ICON_PLAY = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false" class="ico ico-play"><path d="M8 5v14l11-7z" fill="currentColor" stroke="none"/></svg>';
  var ICON_PAUSE = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false" class="ico ico-pause"><path d="M8 5h3v14H8zM13 5h3v14h-3z" fill="currentColor" stroke="none"/></svg>';

  /* A visitor who asked for less motion gets a still frame, not a loop they have to hunt for. */
  function initAutoVideos() {
    var still = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    document.querySelectorAll('.vid--auto').forEach(function (w) {
      var v = w.querySelector('video');
      if (!v) return;
      if (still) { v.removeAttribute('autoplay'); v.pause(); w.setAttribute('data-paused', 'true'); }
      /* the icon must follow the ELEMENT, not the moment we happened to look at it: autoplay has
         usually not started yet at boot, so painting once left a play icon on a running clip */
      v.addEventListener('play', function () { w.removeAttribute('data-paused'); paintToggle(w); });
      v.addEventListener('pause', function () { w.setAttribute('data-paused', 'true'); paintToggle(w); });
      paintToggle(w);
    });
  }

  /* Dots replace the arrow pair on touch. They say how many slides there are and which one you
     are on, which the arrows never did, and they cost 7px of paint instead of two 42px circles. */
  function initDots() {
    document.querySelectorAll('[data-slider]').forEach(function (wrap) {
      if (wrap.querySelector(':scope > .slider-dots')) return;
      var track = wrap.querySelector('.track');
      if (!track) return;
      /* A gallery thumb strip is already a row of position indicators. Nine dots under nine
         thumbs is the same information twice; measured on the books PDP at 390px. */
      if (wrap.classList.contains('gallery-thumbs-slider')) return;
      var slides = Array.prototype.slice.call(track.children);
      if (slides.length < 2) return;
      var dots = document.createElement('div');
      dots.className = 'slider-dots';
      dots.setAttribute('role', 'tablist');
      slides.forEach(function (sl, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.setAttribute('aria-label', 'Слайд ' + (i + 1) + ' от ' + slides.length);
        b.addEventListener('click', function () {
          track.scrollTo({ left: sl.offsetLeft - track.offsetLeft, behavior: 'smooth' });
        });
        dots.appendChild(b);
      });
      (wrap.querySelector('.slider-nav') || track).insertAdjacentElement('afterend', dots);
      var paint = function () {
        /* The anchor is the LEFTMOST slide in view, not the one nearest the middle. On a track
           showing 2.35 slides the midpoint lands on slide 2 while slide 1 is fully on screen, so
           the dots said "you are on 2" to someone looking at 1. Measured on the books PDP image
           slider at 390px, 2026-09-13. With one slide per view the two rules agree. */
        var left = track.scrollLeft;
        var best = 0, bd = Infinity;
        slides.forEach(function (sl, i) {
          var d = Math.abs((sl.offsetLeft - track.offsetLeft) - left);
          if (d < bd - 1) { bd = d; best = i; }
        });
        Array.prototype.forEach.call(dots.children, function (b, i) {
          if (i === best) b.setAttribute('aria-current', 'true'); else b.removeAttribute('aria-current');
        });
      };
      var tick = null;
      track.addEventListener('scroll', function () {
        if (tick) return;
        tick = requestAnimationFrame(function () { tick = null; paint(); });
      }, { passive: true });
      paint();
      PAINTERS.push(paint);
    });
  }
  var PAINTERS = [];
  function repaintDots() { PAINTERS.forEach(function (f) { try { f(); } catch (e) {} }); }

  /* Adaptive height for the PDP quote carousel (owner ruling round 2: swipe on mobile, do not
     stack). A one-per-view track is as tall as its tallest slide, which is what left 87px and
     110px of empty box under the two short quotes in round 1. Sizing the track to the slide the
     visitor is actually on keeps the swipe and keeps the buy column short, which is what puts the
     carrier badges back within reach of the button. Applied at every width: desktop carried the
     same defect from the same cause, 63px under quote 1 and 86px under quote 2. */
  function fitReviewTrack() {
    document.querySelectorAll('.s-main-product .review-slider .track').forEach(function (track) {
      var slides = Array.prototype.slice.call(track.children);
      if (!slides.length) return;
      var left = track.scrollLeft, best = slides[0], bd = Infinity;
      slides.forEach(function (sl) {
        var d = Math.abs((sl.offsetLeft - track.offsetLeft) - left);
        if (d < bd) { bd = d; best = sl; }
      });
      var h = best.getBoundingClientRect().height;
      if (h > 0) { track.setAttribute('data-adaptive', 'true'); track.style.height = Math.ceil(h) + 'px'; }
    });
  }
  (function bindReviewTracks() {
    document.querySelectorAll('.s-main-product .review-slider .track').forEach(function (track) {
      var settle = null;
      track.addEventListener('scroll', function () {
        clearTimeout(settle);
        settle = setTimeout(fitReviewTrack, 120);
      }, { passive: true });
      if ('onscrollend' in track) track.addEventListener('scrollend', function () { clearTimeout(settle); fitReviewTrack(); });
    });
  })();

  /* Horizon scrolls an INNER container (.page-wrapper) above 990px, which is why gate G1 forbids
     window.scrollY / window scroll listeners outright: they silently stop firing there. Scroll
     READING goes through a capturing document listener (the shape initStickyHeader uses), which
     catches a scroll event from any container. Programmatic scrolling goes through the ONE
     getScrollContainer() in section 2 (G1c). A second, mock-era getScrollContainer() used to sit
     here and walk up from #main: function hoisting let it override the Horizon-safe one, Horizon
     has no #main (it is #MainContent), so it returned the document, which does not scroll above
     990px, and the scroll-to-top arrow did nothing on every desktop page (Yoan, 2026-09-26; G1e). */
  function scrollTopOf(target) {
    if (!target || target === document || target === document.documentElement || target === document.body) {
      return (document.scrollingElement || document.documentElement).scrollTop;
    }
    return typeof target.scrollTop === 'number' ? target.scrollTop : 0;
  }

  /* Scroll-to-top: the live theme's own layout section, ported. It appears after the stored
     `display_after` (400px) and is kept out of the tab order and out of the accessibility tree
     while invisible, so a keyboard or screen reader never lands on a control that is not there. */
  /* ---- gallery swipe (owner walk, 2026-09-13) --------------------------------------
     The PDP hero had NO touch handling at all: the stage only changed when a thumbnail was
     tapped, so on a phone the main image looked like a carousel and did not answer a swipe.
     Reported by the owner as "they don't move to the side".

     This reuses the thumbnail path rather than introducing a second source of truth for
     "which image is showing": a swipe picks the next or previous [data-thumb] and applies the
     same three effects the click handler applies, so the stage, the alt text and aria-current
     can never disagree with each other.

     touchend decides, not touchmove, and nothing calls preventDefault: hijacking the gesture
     would break vertical page scrolling that starts on the image, which is most of them. The
     gesture has to be clearly horizontal (1.5x the vertical travel) and long enough (40px) to
     count, so a tap or a scroll never changes the picture. */
  function galleryStep(gal, dir) {
    var thumbs = [].slice.call(gal.querySelectorAll('[data-thumb]'));
    if (thumbs.length < 2) return;
    var cur = 0;
    for (var i = 0; i < thumbs.length; i++) {
      if (thumbs[i].getAttribute('aria-current') === 'true') { cur = i; break; }
    }
    var next = cur + dir;
    if (next < 0) next = thumbs.length - 1;
    if (next >= thumbs.length) next = 0;
    var el = thumbs[next];
    var stage = gal.querySelector('[data-gallery-stage]');
    goToSlide(gal, el.getAttribute('data-img'));
    thumbs.forEach(function (b) { b.setAttribute('aria-current', 'false'); });
    el.setAttribute('aria-current', 'true');
    /* keep the active thumb in view, because the strip scrolls independently of the stage */
    if (el.scrollIntoView) el.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
  }

  /* Scroll the hero track to the slide carrying this media path. Matching on data-img rather
     than on index is deliberate: the thumbnails and the mobile dots are two separate controls
     that both carry data-thumb, so an index into "all data-thumb elements" is ambiguous the
     moment both are rendered. */
  function goToSlide(gal, img) {
    var track = gal.querySelector('[data-gallery-track]');
    if (!track || !img) return;
    var slide = track.querySelector('[data-gallery-slide][data-img="' + (window.CSS && CSS.escape ? CSS.escape(img) : img) + '"]');
    if (!slide) {
      var all = track.querySelectorAll('[data-gallery-slide]');
      for (var i = 0; i < all.length; i++) if (all[i].getAttribute('data-img') === img) { slide = all[i]; break; }
    }
    if (!slide) return;
    var still = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: still ? 'auto' : 'smooth' });
  }

  /* The track is the source of truth for which image is showing, so the controls follow IT rather
     than the other way round. Synced on settle, never per frame, for the same reason the quote
     carousel is: a control repainting mid-gesture is what the reader sees as jitter. */
  function syncGalleryControls(gal) {
    var track = gal.querySelector('[data-gallery-track]');
    if (!track) return;
    var slides = track.querySelectorAll('[data-gallery-slide]');
    var best = null, bd = Infinity;
    for (var i = 0; i < slides.length; i++) {
      var d = Math.abs((slides[i].offsetLeft - track.offsetLeft) - track.scrollLeft);
      if (d < bd) { bd = d; best = slides[i]; }
    }
    if (!best) return;
    var img = best.getAttribute('data-img');
    gal.querySelectorAll('[data-thumb]').forEach(function (b) {
      b.setAttribute('aria-current', b.getAttribute('data-img') === img ? 'true' : 'false');
    });
    var active = gal.querySelector('.thumb[aria-current="true"]');
    if (active && active.scrollIntoView) active.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
  }
  (function bindGalleryTracks() {
    document.querySelectorAll('[data-gallery]').forEach(function (gal) {
      var track = gal.querySelector('[data-gallery-track]');
      if (!track) return;
      var settle = null;
      track.addEventListener('scroll', function () {
        clearTimeout(settle);
        settle = setTimeout(function () { syncGalleryControls(gal); }, 90);
      }, { passive: true });
      if ('onscrollend' in track) track.addEventListener('scrollend', function () { clearTimeout(settle); syncGalleryControls(gal); });
    });
  })();

  function initGallerySwipe() {
    document.querySelectorAll('[data-gallery]').forEach(function (gal) {
      /* The hero is a scroll-snap track of real slides since 2026-09-14, so the browser owns the
         gesture and this handler must not also run: two handlers on one surface fight, the JS one
         changing the picture while the native scroll is still moving. It stays for any gallery
         that is still a single swapped image. */
      if (gal.querySelector('[data-gallery-track]')) return;
      var stage = gal.querySelector('[data-gallery-stage]');
      var zone = stage ? (stage.closest('.gallery-stage') || stage.parentNode) : null;
      if (!zone || zone.hasAttribute('data-swipe-bound')) return;
      zone.setAttribute('data-swipe-bound', 'true');
      var x0 = 0, y0 = 0, t0 = 0, live = false;
      zone.addEventListener('touchstart', function (ev) {
        if (ev.touches.length !== 1) { live = false; return; }
        x0 = ev.touches[0].clientX; y0 = ev.touches[0].clientY; t0 = Date.now(); live = true;
      }, { passive: true });
      zone.addEventListener('touchend', function (ev) {
        if (!live) return;
        live = false;
        var tch = ev.changedTouches && ev.changedTouches[0];
        if (!tch) return;
        var dx = tch.clientX - x0, dy = tch.clientY - y0;
        if (Date.now() - t0 > 800) return;                    // a slow drag is not a swipe
        if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy) * 1.5) return;
        galleryStep(gal, dx < 0 ? 1 : -1);
      }, { passive: true });
    });
  }

  function initScrollTop() {
    var btn = document.querySelector('[data-scroll-top]');
    if (!btn) return;
    var after = parseInt(btn.getAttribute('data-after'), 10) || 400;
    /* It shows only while the visitor scrolls back up, as the sticky header does, and hides on the way down. Shown on
       every scroll past 400px it sat on the text and prices being read: over content at 15 of 16 scroll stops on the
       books page at 390px and 8 of 16 at 1280, at 390 over the buy box's struck prices, pills and couriers row (audit 8a
       finding 16, measured 31.10.2026). TURN px against the current direction flips it, so momentum jitter cannot flash
       it. Only the page's own scroller counts: a carousel scrolling sideways says nothing about where the reader is. */
    var TURN = 24;
    var shown = null, up = false, mark = null;
    var paint = function (top) {
      if (mark === null) mark = top;
      if (up ? top > mark + TURN : top < mark - TURN) { up = !up; mark = top; }
      else mark = up ? Math.min(mark, top) : Math.max(mark, top);
      var on = up && top > after;
      if (on === shown) return;
      shown = on;
      btn.setAttribute('data-show', on ? 'true' : 'false');
      btn.tabIndex = on ? 0 : -1;
      if (on) btn.removeAttribute('aria-hidden'); else btn.setAttribute('aria-hidden', 'true');
    };
    var tick = null;
    document.addEventListener('scroll', function (ev) {
      var t = ev.target;
      var pageScroll = t === document || t === document.documentElement || t === document.body ||
        (t.classList && t.classList.contains('page-wrapper'));
      if (!pageScroll || tick) return;
      var top = scrollTopOf(t);
      tick = requestAnimationFrame(function () { tick = null; paint(top); });
    }, true);
    btn.addEventListener('click', function () {
      var still = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      getScrollContainer().scrollTo({ top: 0, behavior: still ? 'auto' : 'smooth' });
    });
    paint(scrollTopOf(getScrollContainer()));
  }

  /* ---------- 13. Boot ---------------------------------------------------- */
  function boot() {
    document.querySelectorAll('[data-cart-note]').forEach(function (n) { n.value = Cart.note(); });
    markActiveNav();
    initStickyHeader();
    initAutoVideos();
    initClipControls();
    initGallerySwipe();
    initScrollTop();
    initDots();
    measureTracks();
    fitReviewTrack();
  markActiveNav();
  bindCheckout();
  Cart.refresh();
    Timer.paint();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  /* Exposed for the QA harness only. */
  window.MBStore = { Cart: Cart, money: money, CATALOG: CATALOG, Timer: Timer };
})();
